var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgEl3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1508 25.0249C33.8359 23.5459 30.5209 22.0668 27.1024 20.4821C25.3413 18.0523 24.3054 15.3055 23.9946 12.3474C23.2694 8.96669 23.0623 5.69164 22.9587 2.20531C22.7515 -1.17538 17.8827 -0.435844 17.8827 2.83919C17.9862 14.249 11.7707 23.5459 1.51509 28.0887C-1.1783 29.2508 0.0648034 33.2654 2.55102 33.0541C2.86179 33.2654 3.06897 33.371 3.48334 33.4767C11.8743 35.2726 16.9503 41.9284 17.2611 49.8518C17.0539 51.5422 16.8467 53.2325 16.8467 55.0285C16.8467 55.2398 16.8467 55.4511 16.8467 55.768C16.8467 58.8318 21.4048 58.6205 21.9227 55.8737C22.3371 53.7608 22.4407 51.7535 22.4407 49.7462C23.9946 40.7662 29.6921 33.6879 38.3939 29.9903C41.1909 28.8282 40.0514 24.8136 37.1508 25.0249ZM20.2653 40.3437C17.9862 35.6952 14.1533 31.9976 8.97371 29.779C13.9461 26.3983 17.7791 21.8555 20.1617 16.4676C21.9228 21.9612 24.9269 26.7153 29.8994 28.9339C25.6521 31.892 22.4407 35.8009 20.2653 40.3437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgEl3);
export default __webpack_public_path__ + "static/media/bg-el-3.0ec2bd780609f35da61702340415c289.svg";
export { ForwardRef as ReactComponent };